/**
 * 异步数据的状态
 */


export const PENDING = 'PENDING'; // 请求中
export const FAILURE = 'FAILURE'; // 响应失败
export const SUCCESS = 'SUCCESS'; // 响应成功
export const CANCEL = 'CANCEL'; // 取消
export const CONTINUE = 'CONTINUE'; // 继续（分段请求需要）
export const END = 'END'; // 结尾（分页请求需要）


/**
 * 是否处于loading状态
 *
 * @export
 * @param {any} status 状态值
 * @param {boolean} [includeUndefined=false] 是否包含状态值为`undefined`
 */
export function isLoading(status, includeUndefined = false) {
  if (status === PENDING) return true;

  if (includeUndefined && status === undefined) return true;

  return false;
}



// WEBPACK FOOTER //
// ./src/utils/status.js